import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import { IReferenceNotificationListDTO } from '../../../services/setpoint-administration-service/Models';
import { ListItemText, useTheme } from '@mui/material';



export type NotificationListSummaryListProps = {
    title: string,
    items: IReferenceNotificationListDTO[],
};

export function NotificationListSummaryList({
    items,
    title,
}: NotificationListSummaryListProps) {

    const theme = useTheme();
    
    return (
        <List
            dense
            component='nav'
            aria-labelledby="notification-list-subheader"
            subheader={
                <ListSubheader id="notification-list-subheader" 
                        component='div' 
                        sx={{fontSize: '1.1rem'}} >
                    {title}
                </ListSubheader>
            }>
                {items.map((o, ndx) => 
                    <ListItemText primary={o.name} 
                        key={ndx} 
                        sx={{
                            marginLeft: theme.spacing(2),
                            '& + &': {
                                marginTop: 1
                            }
                        }} />
                )}
        </List>
      );
}
